import { useReferenceState } from '@namespace/common';

const ProfileDataLoadWrapper = () => {
  useReferenceState();

  return null;
};

export default ProfileDataLoadWrapper;
